import { connect } from 'react-redux'
import * as InboxSelectors from 'app/modules/inbox/selectors'
import { fetchInboxList } from 'app/modules/inbox/actions'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, } from 'recompose'
import * as GateSelectors from 'app/modules/gates/selectors'


import classnames from 'classnames'

import IconSVG from 'svg-inline-react'

import PropTypes from 'prop-types'

import 'styles/components/settings/inboxes/ManageInboxes.styl'


const ManageInboxes = React.createClass({
  contextTypes: {
    router: PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      moveForward: false,
    }
  },

  render() {
    if (this.props.children) {
      return this.props.children
    }
    const { hasPremiumDrift } = this.props

    return (
      <div className={classnames('ManageInboxes', { 'move-forward': this.state.moveForward })}>
        {hasPremiumDrift && <button
          className="drift-button drift-button-primary new-inbox-button"
          onClick={this.createInboxClicked}
        >
          New Inbox
        </button>}
        <div className="inboxes">
          {_.map(this.props.inboxesById, (inbox, i) => {
            return (
              <div className="inbox" key={i} onClick={this.inboxClicked.bind(this, inbox)}>
                <IconSVG src={require('!svg-inline?removeTags=true!images/icons/envelope-icon.svg')} />
                <div className="name">{inbox.name}</div>
                <div className="reply-email">{inbox.address}</div>
              </div>
            )
          })}
        </div>
      </div>
    )
  },

  inboxClicked(inbox) {
    window.location = `/settings2/inbox/${inbox.id}`
  },

  createInboxClicked() {
    window.location = `/settings2/inbox/new`
  },
})

const mapStateToProps = (state, props) => ({
  inboxesById: InboxSelectors.inboxes(state).toJS(),
  hasPremiumDrift: GateSelectors.hasStarterPlan(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchInboxList,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.fetchInboxList()
    }
  })
)(ManageInboxes)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/inboxes/ManageInboxes.js